import { type LineItemBuilder } from "../LineItemUpdate";
import dayjs from "dayjs";
import { type LineItemMessage, sameDate } from "../common";
import {
  cartIsDayDisabled,
  getFirstValidDate,
  getNextValidDeliveryDate,
  isBeforeMinimumDate,
  isSunday,
} from "../../dateUtils";

const MSG_INVALID_DATE: LineItemMessage = {
  type: "info",
  key: "cartPage.bulkUpload.invalidDate",
};

const isSundayEnabledForDelivery = window.SCHA.feature.showSundayAsDeliveryDay;

/**
 * Needs to run after refreshing EDD
 * @param lineItem
 */
export function refreshDeliveryDate(lineItem: LineItemBuilder): void {
  lineItem.removeMessage(MSG_INVALID_DATE.key);

  const deliveryDate = lineItem.get("deliveryDate");
  const isManuallyConfigured = lineItem.get("manuallySetRDD");
  if (!isManuallyConfigured || deliveryDate === null) {
    let rdd = deliveryDate;
    if (!rdd) {
      rdd = getFirstValidDate();
    }
    if (isBeforeMinimumDate(dayjs(rdd)) || (!isSundayEnabledForDelivery && isSunday(dayjs(rdd)))) {
      rdd = getNextValidDeliveryDate(dayjs(rdd)).toDate();
    }
    if (!sameDate(deliveryDate, rdd)) {
      lineItem.set("deliveryDate", rdd);
    }
  } else {
    // isManuallyConfigured && deliveryDate !== null
    if (isBeforeMinimumDate(dayjs(deliveryDate)) || (!isSundayEnabledForDelivery && isSunday(dayjs(deliveryDate)))) {
      const rdd = getNextValidDeliveryDate(dayjs(deliveryDate)).toDate();
      if (!sameDate(deliveryDate, rdd)) {
        lineItem.set("deliveryDate", rdd);
      }
      lineItem.addMessage(MSG_INVALID_DATE);
    } else if (lineItem.get("saleCampaignEnabled")) {
      if (cartIsDayDisabled(lineItem.forceBuild(), deliveryDate)) {
        const rdd = getNextValidDeliveryDate(dayjs()).toDate();
        if (!sameDate(deliveryDate, rdd)) {
          lineItem.set("deliveryDate", rdd);
          lineItem.set("manuallySetRDD", false);
        }
        lineItem.addMessage(MSG_INVALID_DATE);
      }
    }
  }
}
